'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFontWeight = undefined;

var _theme = require('../config/data/theme');

var getFontWeight = exports.getFontWeight = function getFontWeight(size) {
    if (size === void 0) {
        size = 'regular';
    }
    return _theme.fontWeights[size];
};
//# sourceMappingURL=font-weight.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/helpers/font-weight.js
// module id = 1863
// module chunks = 0